/**
 * Script para garantir que as interações com o carrinho funcionem corretamente
 */

// Variáveis globais - declaradas no escopo global para evitar problemas de hoisting
let isCartUpdateInProgress = false;

document.addEventListener('DOMContentLoaded', function() {
  console.log('Cart Drawer JS carregado');
  
  // Marcar que JavaScript está ativo
  document.body.classList.add('js-enabled');
  
  // Configurar verificação de integridade do JS
  setupJavaScriptIntegrityCheck();
  
  // Configurar carrinho apenas se JS estiver funcionando
  initializeCartDrawer();
  
  // Verificar se o carrinho existe
  const checkCartExists = setInterval(function() {
    const drawer = document.getElementById('CartDrawerCustom');
    if (drawer) {
      clearInterval(checkCartExists);
      
      // Observar quando o carrinho recebe a classe "active"
      const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.attributeName === 'class' && drawer.classList.contains('active')) {
            // Forçar pointer-events: auto em todos os elementos do carrinho
            drawer.style.pointerEvents = 'auto';
            
            // Aplicar em todos os elementos filhos
            const allElements = drawer.querySelectorAll('*');
            allElements.forEach(function(element) {
              element.style.pointerEvents = 'auto';
            });
            
            // Configurar eventos para botões de quantidade com novas classes
            setupQuantityButtons();
            setupRemoveButtons();
            setupShippingCalculator();
            setupCouponForm();
            
            console.log('Interatividade do carrinho restaurada');
          }
        });
      });
      
      // Iniciar observação
      observer.observe(drawer, { attributes: true });
      
      console.log('Monitoramento de interatividade do carrinho iniciado');
    }
  }, 100);
  
  // Configurar botões de quantidade
  function setupQuantityButtons() {
    // Verificar se o carrinho está disponível
    const drawer = document.getElementById('CartDrawerCustom');
    if (!drawer) {
      console.warn('Carrinho não encontrado, tentando novamente em 500ms');
      setTimeout(setupQuantityButtons, 500);
      return;
    }
    
    // Primeiro remover todos os event listeners antigos
    const cartItems = drawer.querySelectorAll('.drawer-cart-item');
    console.log(`Encontrados ${cartItems.length} itens no carrinho`);
    
    cartItems.forEach(function(item) {
      const quantityControls = item.querySelector('.drawer-quantity-selector');
      
      if (quantityControls) {
        // Clonar e substituir para remover todos os listeners antigos
        const newControls = quantityControls.cloneNode(true);
        quantityControls.parentNode.replaceChild(newControls, quantityControls);
      }
    });
    
    // Agora adicionar novos event listeners aos botões clonados
    const quantityBtns = drawer.querySelectorAll('.drawer-quantity-btn');
    console.log(`Configurando ${quantityBtns.length} botões de quantidade (sem duplicação)`);
    
    quantityBtns.forEach(function(btn) {
      btn.addEventListener('click', handleQuantityButtonClick);
    });
  }
  
  // Handler para mudanças manuais no input de quantidade
  function handleQuantityInputChange(input) {
    // Se já houver uma atualização em andamento, não permitir nova ação
    if (isCartUpdateInProgress) {
      console.log('Atualização de carrinho em andamento, aguarde...');
      return;
    }
    
    const cartItem = input.closest('.drawer-cart-item');
    const itemKey = cartItem ? cartItem.getAttribute('data-cart-item-key') : null;
    
    if (!itemKey) return;
    
    // Obter o valor atual e garantir que seja um número válido
    let newQuantity = parseInt(input.value) || 1;
    
    // Garantir que a quantidade seja pelo menos 1
    if (newQuantity < 1) {
      newQuantity = 1;
      input.value = newQuantity;
    }
    
    // Desabilitar todos os botões de quantidade durante a atualização
    const allQuantityButtons = document.querySelectorAll('.drawer-quantity-btn');
    allQuantityButtons.forEach(btn => btn.disabled = true);
    
    // Atualizar subtotal do item imediatamente
    updateItemSubtotal(cartItem, newQuantity);
    
    // Adicionar classe visual para indicar atualização em andamento
    cartItem.classList.add('updating');
    
    // Marcar que há uma atualização em andamento
    isCartUpdateInProgress = true;
    
    // Mostrar loading overlay
    showCartLoadingOverlay();
    
    // Atualizar o carrinho
    updateCartItemQuantity(itemKey, newQuantity);
  }
  
  // Função para configurar inputs de quantidade
  function setupQuantityInputs() {
    // Selecionar inputs de quantidade dentro do carrinho personalizado
    const quantityInputs = document.querySelectorAll('#CartDrawerCustom .cart-drawer-item-quantity-input');
    
    if (quantityInputs.length > 0) {
      console.log(`Configurando ${quantityInputs.length} inputs de quantidade`);
      
      quantityInputs.forEach(input => {
        // Remover listeners antigos clonando o elemento
        const newInput = input.cloneNode(true);
        input.parentNode.replaceChild(newInput, input);
        
        // Adicionar novo listener para atualizar a quantidade quando o valor mudar
        newInput.addEventListener('change', function() {
          const itemKey = this.getAttribute('data-cart-item-key');
          const newQuantity = parseInt(this.value, 10);
          
          if (itemKey && !isNaN(newQuantity) && newQuantity >= 0) {
            updateCartItemQuantity(itemKey, newQuantity);
          }
        });
      });
    }
  }
  
  // Função para fechar o carrinho lateral
  function closeCartDrawer() {
    const drawer = document.getElementById('CartDrawerCustom');
    const overlay = document.getElementById('CartDrawerCustomOverlay');
    
    if (!drawer) return;
    
    drawer.classList.remove('active');
    if (overlay) overlay.classList.remove('active');
    document.body.style.overflow = '';
    
    setTimeout(() => {
      drawer.style.display = 'none';
      if (overlay) overlay.style.display = 'none';
    }, 300);
    
    console.log('Carrinho fechado');
  }
  
  // Função para inicializar o overlay de loading do carrinho
  function initializeCartLoadingOverlay() {
    console.log('Inicializando overlay de loading do carrinho...');
    
    // Verificar se já existe um overlay
    let overlay = document.querySelector('.cart-drawer-overlay');
    
    // Se não existir, criar um novo
    if (!overlay) {
      overlay = document.createElement('div');
      overlay.className = 'cart-drawer-overlay hidden';
      overlay.innerHTML = `
        <div class="cart-drawer-loading-spinner">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">
            <circle cx="12" cy="12" r="10" fill="none" stroke="currentColor" stroke-width="4" stroke-dasharray="31.4 31.4">
              <animateTransform attributeName="transform" attributeType="XML" type="rotate" from="0 12 12" to="360 12 12" dur="1s" repeatCount="indefinite"/>
            </circle>
          </svg>
          <span>Atualizando carrinho...</span>
        </div>
      `;
      
      // Adicionar ao drawer
      const drawer = document.getElementById('CartDrawerCustom');
      if (drawer) {
        drawer.appendChild(overlay);
      } else {
        // Se o drawer não existir, adicionar ao body
        document.body.appendChild(overlay);
      }
    }
    
    console.log('Overlay de loading do carrinho inicializado com sucesso!');
  }
  
  // Funções para controlar o loading overlay
  function showCartLoadingOverlay() {
    // Tentar encontrar o overlay em ambos os drawers (nativo e customizado)
    const overlays = document.querySelectorAll('.cart-drawer-overlay');
    
    if (overlays.length > 0) {
      overlays.forEach(overlay => {
        overlay.classList.remove('hidden');
        // Forçar reflow para garantir que a animação seja aplicada
        overlay.style.display = 'flex';
      });
      console.log('Overlay mostrado');
    } else {
      console.warn('Overlay não encontrado');
    }
  }
  
  function hideCartLoadingOverlay() {
    // Tentar encontrar o overlay em ambos os drawers (nativo e customizado)
    const overlays = document.querySelectorAll('.cart-drawer-overlay');
    
    if (overlays.length > 0) {
      overlays.forEach(overlay => {
        overlay.classList.add('hidden');
      });
      console.log('Overlay escondido');
    } else {
      console.warn('Overlay não encontrado');
    }
  }
  
  // Handler separado para os botões de quantidade
  function handleQuantityButtonClick(e) {
    e.preventDefault();
    e.stopPropagation();
    
    // Se já houver uma atualização em andamento, não permitir nova ação
    if (isCartUpdateInProgress) {
      console.log('Atualização de carrinho em andamento, aguarde...');
      return;
    }
    
    // Desabilitar o botão e indicar visualmente
    this.disabled = true;
    
    // Desabilitar todos os botões de quantidade durante a atualização
    const allQuantityButtons = document.querySelectorAll('.drawer-quantity-btn');
    allQuantityButtons.forEach(btn => btn.disabled = true);
    
    const action = this.getAttribute('data-action');
    const itemKey = this.getAttribute('data-cart-item-key');
    
    if (!itemKey) {
      enableAllQuantityButtons();
      return;
    }
    
    // Usar seletor específico do item para evitar conflitos
    const cartItem = this.closest('.drawer-cart-item');
    const input = cartItem ? cartItem.querySelector('.drawer-quantity-input') : null;
    
    if (!input) {
      enableAllQuantityButtons();
      return;
    }
    
    let newQuantity = parseInt(input.value) || 1;
    
    if (action === 'increase') {
      newQuantity += 1;
    } else if (action === 'decrease' && newQuantity > 1) {
      newQuantity -= 1;
    } else {
      enableAllQuantityButtons();
      return;
    }
    
    // Atualizar input imediatamente para feedback visual
    input.value = newQuantity;
    
    // Atualizar subtotal do item imediatamente
    updateItemSubtotal(cartItem, newQuantity);
    
    // Adicionar classe visual para indicar atualização em andamento
    cartItem.classList.add('updating');
    
    // Marcar que há uma atualização em andamento
    isCartUpdateInProgress = true;
    
    // Atualizar o carrinho
    updateCartItemQuantity(itemKey, newQuantity);
  }
  
  // Função para reativar todos os botões de quantidade
  function enableAllQuantityButtons() {
    const allQuantityButtons = document.querySelectorAll('.drawer-quantity-btn');
    allQuantityButtons.forEach(btn => btn.disabled = false);
    
    // Remover classe de atualização em andamento
    const updatingItems = document.querySelectorAll('.drawer-cart-item.updating');
    updatingItems.forEach(item => item.classList.remove('updating'));
    
    // Resetar flag de atualização em andamento
    isCartUpdateInProgress = false;
  }
  
  // Handler para botões de remoção
  function handleRemoveButtonClick(e) {
    e.preventDefault();
    
    // Obter o item key do botão clicado
    const btn = e.currentTarget;
    const itemKey = btn.getAttribute('data-cart-item-key') || 
                   btn.closest('[data-cart-item-key]')?.getAttribute('data-cart-item-key');
    
    if (!itemKey) {
      console.error('Não foi possível encontrar a chave do item para remover');
      return;
    }
    
    console.log(`Removendo item com chave: ${itemKey}`);
    removeCartItem(itemKey);
  }
  
  // Configurar botões de remoção
  function setupRemoveButtons() {
    // Verificar se o carrinho está disponível
    const drawer = document.getElementById('CartDrawerCustom');
    if (!drawer) {
      console.warn('Carrinho não encontrado para botões de remoção, tentando novamente em 500ms');
      setTimeout(setupRemoveButtons, 500);
      return;
    }
    
    // Primeiro, remover todos os event listeners antigos clonando os botões
    const removeBtns = drawer.querySelectorAll('.drawer-cart-item-remove');
    console.log(`Configurando ${removeBtns.length} botões de remoção`);
    
    removeBtns.forEach(function(btn) {
      // Clonar e substituir para remover todos os listeners antigos
      const newBtn = btn.cloneNode(true);
      btn.parentNode.replaceChild(newBtn, btn);
    });
    
    // Agora adicionar novos event listeners aos botões clonados
    const updatedRemoveBtns = drawer.querySelectorAll('.drawer-cart-item-remove');
    updatedRemoveBtns.forEach(function(btn) {
      btn.addEventListener('click', handleRemoveButtonClick);
    });
  }
  
  // Configurar calculadora de frete
  function setupShippingCalculator() {
    const shippingWrapper = document.querySelector('.shipping-input-wrapper');
    const shippingForm = document.querySelector('.shipping-form');
    const shippingInput = document.querySelector('.shipping-input');
    
    if (shippingWrapper && shippingForm && shippingInput) {
      // Limpar mensagens antigas
      removeShippingMessages();
      
      // Remover event listeners antigos antes de adicionar novos
      // Usamos uma abordagem com clones para garantir que todos os listeners sejam removidos
      const newForm = shippingForm.cloneNode(true);
      shippingForm.parentNode.replaceChild(newForm, shippingForm);
      
      // Atualizar referências após a substituição
      const updatedForm = document.querySelector('.shipping-form');
      const updatedInput = document.querySelector('.shipping-input');
      
      // Formatar CEP com máscara 00000-000
      updatedInput.addEventListener('input', function(e) {
        let value = e.target.value.replace(/\D/g, '');
        if (value.length > 5) {
          value = value.substring(0, 5) + '-' + value.substring(5, 8);
        }
        e.target.value = value.substring(0, 9);
      });
      
      // Usar o evento de submit do formulário em vez do clique no botão
      updatedForm.addEventListener('submit', function(e) {
        e.preventDefault();
        
        if (updatedInput.value) {
          // Mostrar indicador de carregamento
          showShippingLoading();
          
          // Remover hífen para enviar apenas números
          const cep = updatedInput.value.replace(/\D/g, '');
          if (cep.length === 8) {
            calculateShipping(cep);
          } else {
            removeShippingLoading();
            showShippingError('CEP inválido. Digite um CEP com 8 dígitos.');
          }
        } else {
          showShippingError('Por favor, digite um CEP.');
        }
      });
      
      console.log('Calculadora de frete configurada com sucesso (sem duplicação)');
    }
  }
  
  // Mostrar indicador de carregamento de frete
  function showShippingLoading() {
    removeShippingMessages();
    
    const container = document.querySelector('.shipping-input-wrapper');
    if (container) {
      const loadingEl = document.createElement('div');
      loadingEl.className = 'shipping-loading';
      loadingEl.textContent = 'Calculando...';
      
      // Inserir após o formulário, não dentro do wrapper
      container.insertAdjacentElement('afterend', loadingEl);
    }
  }
  
  // Remover indicador de carregamento
  function removeShippingLoading() {
    const loadingEl = document.querySelector('.shipping-loading');
    if (loadingEl) loadingEl.remove();
  }
  
  // Mostrar erro de frete
  function showShippingError(message) {
    const container = document.querySelector('.shipping-input-wrapper');
    if (container) {
      const errorEl = document.createElement('div');
      errorEl.className = 'shipping-error';
      errorEl.textContent = message;
      
      // Inserir após o wrapper, não dentro dele
      container.insertAdjacentElement('afterend', errorEl);
    }
  }
  
  // Remover todas as mensagens de frete
  function removeShippingMessages() {
    const messages = document.querySelectorAll('.shipping-loading, .shipping-error, .shipping-rates');
    messages.forEach(el => el.remove());
  }
  
  // Exibir opções de frete
  function displayShippingRates(rates) {
    removeShippingLoading();
    
    const container = document.querySelector('.shipping-input-wrapper');
    if (!container) return;
    
    const ratesContainer = document.createElement('div');
    ratesContainer.className = 'shipping-rates';
    
    if (rates.length === 0) {
      ratesContainer.innerHTML = '<p>Não há opções de entrega disponíveis para este CEP.</p>';
    } else {
      const ratesList = document.createElement('ul');
      
      rates.forEach(rate => {
        const rateItem = document.createElement('li');
        const price = rate.price === '0.00' ? 'Grátis' : formatPrice(rate.price * 100);
        rateItem.innerHTML = `<span class="rate-name">${rate.name}</span>: <span class="rate-price">${price}</span>`;
        ratesList.appendChild(rateItem);
      });
      
      ratesContainer.appendChild(ratesList);
    }
    
    // Inserir após o wrapper, não dentro dele
    container.insertAdjacentElement('afterend', ratesContainer);
  }
  
  // Configurar formulário de cupom
  function setupCouponForm() {
    const couponForm = document.querySelector('.cart-discount-form');
    const couponBtn = document.querySelector('.cart-discount-button');
    const couponInput = document.querySelector('.cart-discount-input');
    
    if (couponForm && couponBtn && couponInput) {
      // Limpar mensagens antigas
      removeCouponMessages();
      
      // Remover event listeners antigos antes de adicionar novos
      // Usamos uma abordagem com clones para garantir que todos os listeners sejam removidos
      const newForm = couponForm.cloneNode(true);
      couponForm.parentNode.replaceChild(newForm, couponForm);
      
      // Atualizar referências após a substituição
      const updatedForm = document.querySelector('.cart-discount-form');
      const updatedBtn = document.querySelector('.cart-discount-button');
      const updatedInput = document.querySelector('.cart-discount-input');
      
      // Adicionar novo event listener apenas ao formulário
      updatedForm.addEventListener('submit', function(e) {
        e.preventDefault();
        
        if (updatedInput.value.trim()) {
          // Mostrar indicador de carregamento
          showCouponLoading();
          
          // Aplicar cupom
          applyCoupon(updatedInput.value.trim());
        } else {
          showCouponError('Por favor, digite um código de cupom.');
        }
      });
      
      // Não precisamos de um listener separado para o botão, já que ele já submete o formulário
      // Isso evita a duplicação de chamadas
      
      console.log('Formulário de cupom configurado com sucesso (sem duplicação)');
    }
  }
  
  // Mostrar indicador de carregamento de cupom
  function showCouponLoading() {
    removeCouponMessages();
    
    const container = document.querySelector('.cart-discount');
    if (container) {
      const loadingEl = document.createElement('div');
      loadingEl.className = 'coupon-loading';
      loadingEl.textContent = 'Aplicando...';
      container.appendChild(loadingEl);
    }
  }
  
  // Remover indicador de carregamento de cupom
  function removeCouponLoading() {
    const loadingEl = document.querySelector('.coupon-loading');
    if (loadingEl) loadingEl.remove();
  }
  
  // Mostrar erro de cupom
  function showCouponError(message) {
    const container = document.querySelector('.cart-discount');
    if (container) {
      const errorEl = document.createElement('div');
      errorEl.className = 'coupon-error';
      errorEl.textContent = message;
      container.appendChild(errorEl);
    }
  }
  
  // Mostrar sucesso de cupom
  function showCouponSuccess(message) {
    const container = document.querySelector('.cart-discount');
    if (container) {
      const successEl = document.createElement('div');
      successEl.className = 'coupon-success';
      successEl.textContent = message;
      container.appendChild(successEl);
    }
  }
  
  // Remover todas as mensagens de cupom
  function removeCouponMessages() {
    const messages = document.querySelectorAll('.coupon-loading, .coupon-error, .coupon-success');
    messages.forEach(el => el.remove());
  }
  
  // Função para atualizar quantidade do item
  function updateCartItemQuantity(itemKey, quantity) {
    // Definir timeout para garantir que a operação não fique presa indefinidamente
    const timeoutPromise = new Promise((_, reject) => {
      setTimeout(() => reject(new Error('Tempo limite excedido')), 5000);
    });
    
    // Fazer a requisição com timeout
    Promise.race([
      fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          id: itemKey,
          quantity: quantity
        })
      }),
      timeoutPromise
    ])
    .then(response => response.json())
    .then(cartData => {
      // Atualizar carrinho dinamicamente sem reload
      updateCartDisplay(cartData);
      
      // Reconfigurar eventos para garantir que novos elementos funcionem
      rebindCartEvents();
      
      // Reativar todos os botões de quantidade
      enableAllQuantityButtons();
    })
    .catch(error => {
      console.error('Erro ao atualizar quantidade:', error);
      
      // Mostrar mensagem de erro para o usuário
      const errorMessage = document.createElement('div');
      errorMessage.className = 'cart-error-message';
      errorMessage.textContent = 'Ocorreu um erro ao atualizar o carrinho. Por favor, tente novamente.';
      
      const cartFooter = document.querySelector('.cart-footer');
      if (cartFooter) {
        cartFooter.prepend(errorMessage);
        
        // Remover a mensagem após alguns segundos
        setTimeout(function() {
          errorMessage.remove();
        }, 3000);
      }
      
      // Reativar todos os botões mesmo em caso de erro
      enableAllQuantityButtons();
    });
  }
  
  // Função para remover item
  function removeCartItem(itemKey) {
    // Verificar se já há uma atualização em andamento
    if (isCartUpdateInProgress) {
      console.log('Atualização de carrinho em andamento, aguarde...');
      return;
    }
    
    // Marcar que há uma atualização em andamento
    isCartUpdateInProgress = true;
    
    // Mostrar overlay de loading
    showCartLoadingOverlay();
    
    // Desabilitar todos os botões durante a atualização
    const allQuantityButtons = document.querySelectorAll('.drawer-quantity-btn');
    allQuantityButtons.forEach(btn => btn.disabled = true);
    
    // Desabilitar todos os botões de remoção durante a atualização
    const allRemoveButtons = document.querySelectorAll('.drawer-cart-item-remove');
    allRemoveButtons.forEach(btn => btn.disabled = true);
    
    // Adicionar classe visual para indicar atualização em andamento e esconder visualmente o item
    const cartItem = document.querySelector(`.drawer-cart-item[data-cart-item-key="${itemKey}"]`);
    if (cartItem) {
      cartItem.classList.add('updating');
      // Esconder visualmente o item imediatamente
      cartItem.style.opacity = '0.5';
      cartItem.style.pointerEvents = 'none';
      cartItem.style.height = cartItem.offsetHeight + 'px';
      
      // Animação de remoção
      setTimeout(() => {
        cartItem.style.height = '0';
        cartItem.style.opacity = '0';
        cartItem.style.overflow = 'hidden';
        cartItem.style.transition = 'all 0.3s ease-out';
        cartItem.style.marginTop = '0';
        cartItem.style.marginBottom = '0';
        cartItem.style.paddingTop = '0';
        cartItem.style.paddingBottom = '0';
      }, 100);
    }
    
    // Definir timeout para garantir que a operação não fique presa indefinidamente
    const timeoutPromise = new Promise((_, reject) => {
      setTimeout(() => reject(new Error('Tempo limite excedido')), 5000);
    });
    
    // Fazer a requisição com timeout
    Promise.race([
      fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: itemKey,
          quantity: 0
        })
      }),
      timeoutPromise
    ])
    .then(response => {
      if (!response.ok) throw new Error('Erro ao remover item');
      return response.json();
    })
    .then(cart => {
      console.log('Item removido com sucesso:', cart);
      // Remover completamente o item do DOM após a animação
      if (cartItem) {
        setTimeout(() => {
          cartItem.remove();
        }, 300);
      }
      updateCartDisplay(cart);
    })
    .catch(error => {
      console.error('Erro ao remover item do carrinho:', error);
      // Restaurar o item em caso de erro
      if (cartItem) {
        cartItem.style.opacity = '';
        cartItem.style.pointerEvents = '';
        cartItem.style.height = '';
        cartItem.style.overflow = '';
        cartItem.style.transition = '';
        cartItem.style.margin = '';
        cartItem.style.padding = '';
      }
      alert('Ocorreu um erro ao remover o item. Por favor, tente novamente.');
    })
    .finally(() => {
      // Reativar botões e limpar estado após um breve delay
      setTimeout(() => {
        enableAllQuantityButtons();
        rebindCartEvents();
      }, 300);
    });
  }
  
  // Função para calcular frete
  function calculateShipping(cep) {
    console.log('Calculando frete para CEP:', cep);
    
    // Obter o primeiro item do carrinho para o cálculo
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        if (cart.items.length === 0) {
          removeShippingLoading();
          showShippingError('O carrinho está vazio. Adicione produtos para calcular o frete.');
          return;
        }
        
        // Usar a API do Shopify para calcular frete
        const firstItem = cart.items[0];
        
        // Montar a URL para cálculo de frete
        const url = `/shipping/rates.json?shipping_address[zip]=${cep}&shipping_address[country]=Brazil`;
        
        fetch(url)
          .then(response => {
            if (!response.ok) {
              throw new Error('Erro ao calcular frete');
            }
            return response.json();
          })
          .then(data => {
            if (data && data.shipping_rates) {
              displayShippingRates(data.shipping_rates);
            } else {
              removeShippingLoading();
              showShippingError('Não foi possível calcular o frete para este CEP.');
            }
          })
          .catch(error => {
            console.error('Erro ao calcular frete:', error);
            removeShippingLoading();
            showShippingError('Ocorreu um erro ao calcular o frete. Tente novamente.');
          });
      })
      .catch(error => {
        console.error('Erro ao obter carrinho:', error);
        removeShippingLoading();
        showShippingError('Ocorreu um erro ao obter informações do carrinho. Tente novamente.');
      });
  }
  
  // Função para aplicar cupom
  function applyCoupon(code) {
    console.log('Aplicando cupom:', code);
    
    // Usar a API do Shopify para aplicar cupom
    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        attributes: {
          'discount_code': code
        }
      })
    })
    .then(response => response.json())
    .then(cartData => {
      showCouponError('Ocorreu um erro ao aplicar o cupom. Tente novamente.');
    });
  }
  
  // Função alternativa para aplicar desconto via checkout
  function applyDiscountViaCheckout(code) {
    // Redirecionar para checkout com código de desconto
    const checkoutUrl = `/discount/${code}?redirect=/cart`;
    
    // Usar um iframe oculto para aplicar o desconto sem sair da página
    const iframe = document.createElement('iframe');
    iframe.style.display = 'none';
    iframe.src = checkoutUrl;
    
    iframe.onload = function() {
      // Remover iframe após carregar
      setTimeout(() => {
        document.body.removeChild(iframe);
        
        // Verificar se o desconto foi aplicado
        fetch('/cart.js')
          .then(response => response.json())
          .then(cart => {
            if (cart.total_discount > 0) {
              removeCouponLoading();
              showCouponSuccess('Cupom aplicado com sucesso!');
              
              // Atualizar exibição do carrinho
              updateCartDisplay(cart);
            } else {
              removeCouponLoading();
              showCouponError('Código de cupom inválido ou expirado.');
            }
          })
          .catch(error => {
            console.error('Erro ao verificar cupom:', error);
            removeCouponLoading();
            showCouponError('Ocorreu um erro ao verificar o cupom. Tente novamente.');
          });
      }, 2000);
    };
    
    document.body.appendChild(iframe);
  }
  
  // Função para atualizar exibição do carrinho
  function updateCartDisplay(cartData) {
    // Atualizar contadores de quantidade
    if (cartData.items) {
      cartData.items.forEach(function(item) {
        const quantityInput = document.querySelector(`[data-cart-item-key="${item.key}"]`)?.parentNode?.querySelector('.drawer-quantity-input');
        if (quantityInput) {
          quantityInput.value = item.quantity;
        }
        
        // Atualizar preço do item
        const itemElement = document.querySelector(`[data-cart-item-key="${item.key}"]`);
        if (itemElement) {
          const priceElement = itemElement.closest('.drawer-cart-item')?.querySelector('.drawer-item-price');
          if (priceElement) {
            priceElement.textContent = formatPrice(item.line_price);
          }
        }
      });
    }
    
    // Atualizar total do carrinho
    const totalElement = document.querySelector('.cart-total-value');
    if (totalElement && cartData.total_price !== undefined) {
      totalElement.textContent = formatPrice(cartData.total_price);
    }
    
    // Remover itens com quantidade 0
    if (cartData.items) {
      cartData.items.forEach(function(item) {
        if (item.quantity === 0) {
          const itemElement = document.querySelector(`[data-cart-item-key="${item.key}"]`);
          if (itemElement) {
            const cartItem = itemElement.closest('.drawer-cart-item');
            if (cartItem) {
              cartItem.style.transition = 'opacity 0.3s ease';
              cartItem.style.opacity = '0';
              setTimeout(() => {
                cartItem.remove();
                // Re-bind eventos após remoção
                rebindCartEvents();
              }, 300);
            }
          }
        }
      });
    }
    
    // Atualizar contador do carrinho no header - Versão melhorada
    if (cartData.item_count !== undefined) {
      // Atualizar todos os contadores possíveis
      const counters = document.querySelectorAll('.cart-count, [data-cart-count], .cart-count-bubble span');
      counters.forEach(function(counter) {
        counter.textContent = cartData.item_count;
      });
      
      // Atualizar especificamente o contador na bolha do carrinho
      const cartCountBubbles = document.querySelectorAll('.cart-count-bubble');
      cartCountBubbles.forEach(function(bubble) {
        // Se não houver itens, esconder a bolha
        if (cartData.item_count === 0) {
          bubble.style.display = 'none';
        } else {
          bubble.style.display = '';
          
          // Garantir que o span dentro da bolha tenha o valor correto
          const span = bubble.querySelector('span');
          if (span) {
            span.textContent = cartData.item_count;
          } else {
            // Se não houver span, atualizar o texto diretamente
            bubble.textContent = cartData.item_count;
          }
        }
      });
      
      // Atualizar atributos data-cart-count em todos os elementos
      const dataCountElements = document.querySelectorAll('[data-cart-count]');
      dataCountElements.forEach(function(element) {
        element.setAttribute('data-cart-count', cartData.item_count);
      });
      
      // Armazenar o valor no localStorage para persistência
      try {
        localStorage.setItem('cart_item_count', cartData.item_count);
      } catch (e) {
        console.error('Erro ao salvar contador no localStorage:', e);
      }
    }
    
    // Re-bind eventos para garantir funcionalidade
    rebindCartEvents();
    
    console.log('Carrinho atualizado dinamicamente:', cartData);
  }
  
  // Função para revinculação de eventos após alterações no DOM
  function rebindCartEvents() {
    console.log('Revinculando eventos do carrinho...');
    
    // Limpar flag de atualização em andamento
    isCartUpdateInProgress = false;
    
    // Reativar botões
    enableAllQuantityButtons();
    
    // Configurar botões de quantidade
    setupQuantityButtons();
    
    // Configurar inputs de quantidade
    setupQuantityInputs();
    
    // Configurar botões de remoção
    setupRemoveButtons();
    
    // Configurar calculadora de frete
    setupShippingCalculator();
    
    // Configurar formulário de cupom
    setupCouponForm();
    
    // Esconder overlay de loading após revinculação completa
    hideCartLoadingOverlay();
  }
  
  // Função para atualizar subtotal do item
  function updateItemSubtotal(cartItem, quantity) {
    if (!cartItem) return;
    
    const unitPriceEl = cartItem.querySelector('.drawer-item-unit-price');
    const subtotalEl = cartItem.querySelector('.drawer-item-subtotal');
    
    if (unitPriceEl && subtotalEl) {
      // Extrair o preço unitário do texto (removendo R$ e convertendo vírgula para ponto)
      const unitPriceText = unitPriceEl.textContent.trim();
      const unitPrice = parseFloat(unitPriceText.replace('R$ ', '').replace(',', '.')) || 0;
      
      // Calcular novo subtotal
      const subtotal = unitPrice * quantity;
      
      // Formatar e atualizar o subtotal
      subtotalEl.textContent = formatPrice(subtotal * 100);
    }
  }
  
  // Função para atualizar a quantidade de um item no carrinho
  function updateCartItemQuantity(itemKey, newQuantity) {
    // Mostrar overlay de loading
    showCartLoadingOverlay();
    
    // Desabilitar todos os botões durante a atualização
    const allQuantityButtons = document.querySelectorAll('.drawer-quantity-btn');
    allQuantityButtons.forEach(btn => btn.disabled = true);
    
    // Fazer a requisição para atualizar o carrinho
    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        id: itemKey,
        quantity: newQuantity
      })
    })
    .then(response => response.json())
    .then(cart => {
      console.log('Carrinho atualizado:', cart);
      
      // Atualizar o conteúdo do carrinho
      updateCartDisplay(cart);
      
      // Reativar os botões
      enableAllQuantityButtons();
      
      // Esconder overlay de loading
      hideCartLoadingOverlay();
      
      // Resetar flag de atualização em andamento
      isCartUpdateInProgress = false;
    })
    .catch(error => {
      console.error('Erro ao atualizar carrinho:', error);
      
      // Reativar os botões mesmo em caso de erro
      enableAllQuantityButtons();
      
      // Esconder overlay de loading
      hideCartLoadingOverlay();
      
      // Resetar flag de atualização em andamento
      isCartUpdateInProgress = false;
      
      // Mostrar mensagem de erro
      alert('Erro ao atualizar o carrinho. Por favor, tente novamente.');
    });
  }
  
  // Função para remover um item do carrinho
  function removeCartItem(itemKey) {
    // Mostrar overlay de loading
    showCartLoadingOverlay();
    
    // Fazer a requisição para remover o item do carrinho
    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        id: itemKey,
        quantity: 0
      })
    })
    .then(response => response.json())
    .then(cart => {
      console.log('Item removido do carrinho:', cart);
      
      // Atualizar o conteúdo do carrinho
      updateCartDisplay(cart);
      
      // Esconder overlay de loading
      hideCartLoadingOverlay();
      
      // Resetar flag de atualização em andamento
      isCartUpdateInProgress = false;
    })
    .catch(error => {
      console.error('Erro ao remover item do carrinho:', error);
      
      // Esconder overlay de loading
      hideCartLoadingOverlay();
      
      // Resetar flag de atualização em andamento
      isCartUpdateInProgress = false;
      
      // Mostrar mensagem de erro
      alert('Erro ao remover o item do carrinho. Por favor, tente novamente.');
    });
  }
  
  // Função para atualizar a exibição do carrinho após mudanças
  function updateCartDisplay(cart) {
    // Atualizar contador de itens no cabeçalho
    updateCartCounters(cart.item_count);
    
    // Verificar se o carrinho está vazio
    if (cart.item_count === 0) {
      // Mostrar mensagem de carrinho vazio
      const drawer = document.getElementById('CartDrawerCustom');
      if (drawer) {
        drawer.innerHTML = `
          <div class="cart-drawer-header">
            <h2 class="cart-drawer-title">meu carrinho</h2>
            <button class="cart-drawer-close" aria-label="Fechar">×</button>
          </div>
          <div class="cart-drawer-empty">
            <div class="cart-empty-message">o carrinho está vazio</div>
            <a href="/collections/all" class="choose-products-button">escolher produtos</a>
          </div>
        `;
        
        // Reativar botão de fechar
        const closeBtn = drawer.querySelector('.cart-drawer-close');
        if (closeBtn) {
          closeBtn.addEventListener('click', closeCartDrawer);
        }
      }
      return;
    }
    
    // Se o carrinho não está vazio, fazer uma requisição para obter o HTML atualizado do carrinho
    fetch('/cart?view=drawer')
      .then(response => response.text())
      .then(html => {
        // Atualizar o conteúdo do drawer com o HTML recebido
        const drawer = document.getElementById('CartDrawerCustom');
        if (drawer) {
          drawer.innerHTML = html;
          
          // Reconfigurar todos os eventos após atualizar o HTML
          rebindCartEvents();
        }
      })
      .catch(error => {
        console.error('Erro ao atualizar conteúdo do carrinho:', error);
      });
  }
  
  // Função para atualizar todos os contadores de itens do carrinho
  function updateCartCounters(count) {
    // Atualizar contadores no cabeçalho
    const counters = document.querySelectorAll('.cart-count-bubble span[aria-hidden="true"]');
    counters.forEach(counter => {
      counter.textContent = count;
    });
    
    // Atualizar contadores acessíveis
    const accessibleCounters = document.querySelectorAll('.cart-count-bubble .visually-hidden');
    accessibleCounters.forEach(counter => {
      counter.textContent = count === 1 ? '1 item' : `${count} itens`;
    });
    
    // Atualizar contador no localStorage para persistência
    try {
      localStorage.setItem('cart_count', count);
    } catch (e) {
      console.warn('Não foi possível salvar contador no localStorage');
    }
  }
  
  // Função auxiliar para formatar preço
  function formatPrice(cents) {
    return 'R$ ' + (cents / 100).toFixed(2).replace('.', ',');
  }
  
  // Função para rebind eventos do carrinho
  function rebindCartEvents() {
    console.log('Reconfigurando todos os eventos do carrinho...');
    
    // Configurar botão de fechar
    const closeBtn = document.querySelector('#CartDrawerCustom .cart-drawer-close');
    if (closeBtn) {
      // Remover listeners antigos
      const newCloseBtn = closeBtn.cloneNode(true);
      closeBtn.parentNode.replaceChild(newCloseBtn, closeBtn);
      
      // Adicionar novo listener
      newCloseBtn.addEventListener('click', closeCartDrawer);
    }
    
    // Configurar botões de quantidade
    setupQuantityButtons();
    
    // Configurar inputs de quantidade
    setupQuantityInputs();
    
    // Configurar botões de remoção
    setupRemoveButtons();
    
    // Configurar calculadora de frete
    setupShippingCalculator();
    
    // Configurar formulário de cupom
    setupCouponForm();
    
    console.log('Eventos do carrinho reconfigurados com sucesso!');
  }
  
  // Função para verificar integridade do JavaScript
  function setupJavaScriptIntegrityCheck() {
    // Verificar se elementos essenciais estão presentes
    const healthCheck = setInterval(function() {
      const drawer = document.getElementById('CartDrawerCustom');
      const quantityBtns = document.querySelectorAll('.drawer-quantity-btn');
      const removeBtns = document.querySelectorAll('.drawer-cart-item-remove');
      
      if (drawer && quantityBtns.length === 0 && removeBtns.length === 0) {
        // Se drawer existe mas botões não têm event listeners, rebind
        console.warn('Cart drawer sem eventos detectado - rebinding...');
        rebindCartEvents();
      }
    }, 2000);
    
    // Parar verificação após 30 segundos
    setTimeout(() => clearInterval(healthCheck), 30000);
  }
  
  // Função para inicializar carrinho
  function initializeCartDrawer() {
    // Verificar se elementos críticos existem
    const drawer = document.getElementById('CartDrawerCustom');
    if (!drawer) {
      console.error('Cart drawer não encontrado - desabilitando funcionalidades');
      disableCartDrawerFunctionality();
      return;
    }
    
    // Inicializar overlay de loading
    initializeCartLoadingOverlay();
    
    // Mostrar overlay inicialmente para feedback visual
    showCartLoadingOverlay();
    
    // Configurar todos os eventos do carrinho
    rebindCartEvents();
    
    // Esconder overlay após inicialização
    setTimeout(hideCartLoadingOverlay, 500);
    
    // Adicionar classe para indicar que JS está funcionando
    drawer.classList.add('js-ready');
    
    // Esconder overlay após inicialização
    setTimeout(function() {
      hideCartLoadingOverlay();
    }, 500);
    
    console.log('Cart drawer inicializado com sucesso');
  }
  
  // Função para desabilitar drawer se JS não funcionar
  function disableCartDrawerFunctionality() {
    // Verificar se o drawer está realmente disponível e funcional
    const cartDrawer = document.querySelector('cart-drawer');
    const drawerFunctional = cartDrawer && typeof cartDrawer.renderContents === 'function';
    
    // Só desabilitar se o drawer não estiver funcionando corretamente
    if (!drawerFunctional) {
      const cartTriggers = document.querySelectorAll('[href*="cart"], .cart-link, .drawer-cart-open');
      cartTriggers.forEach(function(trigger) {
        trigger.addEventListener('click', function(e) {
          // Redirecionar para página do carrinho em vez de abrir drawer
          window.location.href = '/cart';
        });
      });
      
      console.log('Cart drawer desabilitado - redirecionando para /cart');
    } else {
      console.log('Cart drawer está funcional - mantendo comportamento AJAX');
    }
  }
});
